import { Box } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { WidgetRenderer } from 'widgets/WidgetRenderer';
import { MultiEditConfigProvider } from 'widgets/store/MultiEditConfigProvider';

import { useAppSelector } from '../../store';
import { selectActivePage } from '../../store/pageSelector';
import { BoundingBox, HoverBox } from '../BoundingBox';
import { ContextMenu } from '../ContextMenu/ContextMenu';
import PortRenderer from '../FlowCore/components/PortRenderer';
import { PageColorVisionFilter } from '../PageArea/PageColorVisionFilter';
import { MultiWidgetToolbarContainer } from '../Toolbar/MultiWidgetToolbarContainer';
import { PageContainer } from './PageContainer';
import { PageScrollContainer } from './PageScrollContainer';
import { PageTransformContainer } from './PageTransformContainer';
import { PageVisionBackground } from './PageVisionBackground';

export const PageArea = (): ReactElement => {
  const activePageId = useAppSelector(selectActivePage);
  return (
    <PageScrollContainer>
      <PageTransformContainer>
        <PageContainer>
          <HoverBox />
          <PageColorVisionFilter>
            <MultiEditConfigProvider>
              <MultiWidgetToolbarContainer />
              <PageVisionBackground pageId={activePageId} />
              <WidgetRenderer pageId={activePageId} />
            </MultiEditConfigProvider>
          </PageColorVisionFilter>
          <div id='smart-guide-container' />
        </PageContainer>
      </PageTransformContainer>
      <ContextMenu />
      <BoundingBox />
      <Box zIndex='port' position='relative' width='full' height='full' pointerEvents='none'>
        <PageTransformContainer readonly={true}>
          <PortRenderer />
        </PageTransformContainer>
      </Box>
    </PageScrollContainer>
  );
};
